import { Link, useApi } from '../lib.jsx';
import { Wordmark } from '../ui.jsx';
import { Report } from './Report.jsx';

/** One saved report, read-only. Nothing here can start collection or call a model. */
export function SampleReport() {
  const { data } = useApi('/api/demo/report');
  const names = data?.scope.targets.map((t) => t.name).join(' vs ');
  return (
    <div className="page">
      <div className="run-head">
        <p className="eyebrow">Sample report</p>
        <h1>{names ? <>What people say about <em>{names}</em></> : 'Sample report'}</h1>
        <p className="small muted">Saved research, read-only · commenter names removed · uses no credits</p>
      </div>
      <Report base="/api/demo" readOnly />
    </div>
  );
}

/** The public sample, for people without a login. */
export function Demo() {
  return (
    <>
      <header className="topbar">
        <Link to="/demo" className="wordmark" aria-label="Yapscape"><Wordmark /></Link>
        <nav className="nav" />
        <div className="userbox"><a className="btn small hide-sm" href="/demo/print" target="_blank" rel="noopener">Print or save as PDF</a><Link className="btn primary small" to="/">Sign in</Link></div>
      </header>
      <main><SampleReport /></main>
    </>
  );
}
